
import { Box, Grid, makeStyles, Typography, Avatar, Hidden, SwipeableDrawer, Divider } from '@material-ui/core'
import React, { useState } from 'react'
import bigLogoDark from "../media/bigLogoDark.svg"
import { Link } from "react-router-dom"
const useStyles = makeStyles((theme) => ({
    Nav: {
        backgroundColor: theme.colors.blue,
        fontFamily: theme.font.fontFamily,
        fontWeight: 700,
        height: "90px",
        padding: "10px",
        zIndex: 3
    },
    link: {
        textDecoration: "none",
        marginRight: '30px',
    },
    sideDarkBlueBox: {
        backgroundColor: theme.colors.blue,
        height: '100%',
        width: "150px",
        padding: "30px"
    },
    white: {
        color: theme.colors.white,
        cursor: "pointer",
        fontFamily: theme.font.fontFamily,
        fontWeight: 700,
        transition: ".5s",
        '&:hover': {
            color: theme.colors.orange,
            borderBottom: `2px solid ${theme.colors.orange}`,
            transition: ".5s",
        },
        [theme.breakpoints.down("md")]: {
            fontSize: ".9rem",
            '&:hover': {
                color: theme.colors.orange,
                borderBottom: 0,
                transition: ".5s",
            },

        }
    },
    cross: {

        color: theme.colors.white,
        cursor: "pointer",
        fontFamily: theme.font.fontFamily,
        fontWeight: 700,
        transition: ".5s",
        '&:hover': {
            color: theme.colors.orange,
            transition: ".5s",
        },
        [theme.breakpoints.down("md")]: {
            fontSize: ".9rem"
        }

    },

    drawers: {
        color: theme.colors.white,
        cursor: "pointer",
        fontFamily: theme.font.fontFamily,
        fontWeight: 700,

        '&:hover': {
            color: theme.colors.orange,


        },
        [theme.breakpoints.down("md")]: {
            fontSize: "1.5rem"
        }
    }
}));
function Navbar() {
    const classes = useStyles();
    const [open, setOpen] = useState(false)
    const toggleDrawer = (open) => (event) => {
        if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setOpen(open);
    };
    return (
        <Box width={1} className={classes.Nav} position="fixed">
            <Box maxWidth="1248px" mx="auto" p="20px">
                <Grid container alignItems="center" justify="space-between"  >
                    <Grid item container xs={8} sm={8} md={3}>
                        <Grid item xs={4}>
                            <Link to="/" className={classes.link}>
                                <img src={bigLogoDark} alt="" width="100px" height="60px" />
                            </Link>
                        </Grid>
                    </Grid>
                    <Hidden smDown>
                        <Grid item container xs={6} style={{ display: "flex", justifyContent: "flex-end" }}>
                            <Link className={classes.link} to="/"><Typography variant="h6" className={classes.white}>Home</Typography></Link>
                            <Link className={classes.link} to="/states"><Typography variant="h6" className={classes.white}>States</Typography></Link>
                            {/* <Link className={classes.link} to="/selling"><Typography variant="h6" className={classes.white}>Sell City</Typography></Link> */}
                            <Link className={classes.link} to="/dashboard"><Typography variant="h6" className={classes.white}>User Dashboard</Typography></Link>
                            <Link className={classes.link} to="/login"> <Typography variant="h6" className={classes.white}>Register</Typography> </Link>
                        </Grid>
                    </Hidden>
                    <Hidden mdUp>
                        <Grid item container xs={1} alignItems="center">
                            <Typography variant="h4" onClick={toggleDrawer(true)} className={classes.drawers}><i className={"fas fa-bars"}></i></Typography>
                        </Grid>
                    </Hidden>
                </Grid>
            </Box>
            <Hidden mdUp>
                <SwipeableDrawer
                    anchor='right'
                    open={open}
                    onClose={toggleDrawer(false)}
                    onOpen={toggleDrawer(true)}
                    style={{ height: "100%" }}
                    className="swipeableDrawer"

                >
                    <div
                        role="presentation"
                        onClick={toggleDrawer(false)}
                        onKeyDown={toggleDrawer(false)}
                        className={classes.sideDarkBlueBox}
                    >
                        <Grid container direction="column" >
                            <Grid item  >
                                <Typography variant="h6" className={classes.cross}> <i class="fas fa-times"></i></Typography>
                            </Grid>
                            <br />
                            <Divider />
                            <Grid item>
                                <Link className={classes.link} to="/"><Typography variant="h6" className={classes.white}>Home</Typography></Link>
                            </Grid>
                            <Divider />
                            <Grid item>
                                <Link className={classes.link} to="/states"><Typography variant="h6" className={classes.white}>States</Typography></Link>
                            </Grid>
                            <Divider />
                            <Grid>
                                <Link className={classes.link} to="/selling"><Typography variant="h6" className={classes.white}>Sell City</Typography></Link>
                            </Grid>
                            <Divider />
                            <Grid item>
                                <Link className={classes.link} to="/dashboard"><Typography variant="h6" className={classes.white}>User Dashboard</Typography></Link>
                            </Grid>
                        </Grid>
                    </div>
                </SwipeableDrawer>
            </Hidden>
        </Box>
    )
}

export default Navbar
